import { makeStyles } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'
import RemoveCircle from '@material-ui/icons/RemoveCircle'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { useTranslate } from 'ra-core'
import { FunctionComponent, ReactNode, useEffect } from 'react'

const useStyles = makeStyles(
  (theme) => ({
    removeButton: {},
    removeIcon: {
      color: theme.palette.error.main,
    },
    isSingleImageButton: {
      position: 'absolute',
    },
  }),
  { name: 'RaFileInputPreview' }
)

interface Props {
  children: ReactNode
  className?: string
  classes?: object
  saving?: boolean
  onRemove: () => void
  file: any
  isSingleImageButton?: boolean
}

const FileInputPreview: FunctionComponent<Props> = ({ children, classes: classesOverride, className, onRemove, saving = false, file, ...rest }) => {
  const classes = useStyles({ children, classes: classesOverride, className, onRemove, saving, file, ...rest })
  const translate = useTranslate()

  useEffect(() => {
    return () => {
      const preview = file.rawFile ? file.rawFile.preview : file.preview

      if (preview) {
        window.URL.revokeObjectURL(preview)
      }
    }
  }, [file])

  return (
    <div className={className} {...rest}>
      <IconButton
        className={classnames(classes.removeButton, rest?.isSingleImageButton && classes.isSingleImageButton)}
        onClick={onRemove}
        disabled={saving}
        aria-label={translate('ra.action.delete')}
        title={translate('ra.action.delete')}
      >
        <RemoveCircle className={classes.removeIcon} />
      </IconButton>
      {children}
    </div>
  )
}

FileInputPreview.propTypes = {
  children: PropTypes.element.isRequired,
  className: PropTypes.string,
  file: PropTypes.object,
  onRemove: PropTypes.func.isRequired,
}

export default FileInputPreview
